export default __webpack_public_path__ + "static/media/20.0d50fcee.jpg";